import { LpTestimonialsCarousel } from '@/features/landing-page/v3/sections/lp-testimonials-carousel'
import { LP_GRID } from '@/features/landing-page/v3/lp-grid'

/**
 * lp-v3 "Loved by customers" section — a single testimonial carousel card (author + quote + video)
 * centred on the cream background. SERVER wrapper; the carousel itself is the only client island.
 */
export function LpTestimonialsSection() {
    return (
        // Bordered card section → the card spans the gutter width (16/30px to the screen edge).
        <section className={`bg-background ${LP_GRID.cardSection} py-[60px] md:py-[40px]`}>
            <LpTestimonialsCarousel />
        </section>
    )
}
